<template>
    <div class="templete_box">
        <div class="templete">
            <div class="wrap">
                <workbench v-show="benchOrInfo" @grandHandle="handleGrandSonEmit" @middleEvent="handleMiddleEvent"/>
                <customerinfo v-if="!benchOrInfo" @fromInfo="handleInfoEmit"/>
            </div>
        </div>
    </div>
</template>

<script>
import workbench from '../../components/customer/workbench'
import customerinfo from '../../components/customer/customerinfo'
export default {
    components: {
        workbench,
        customerinfo
    },
    data(){
        return {
            benchOrInfo: true
        }
    },
    methods: {
        //跳转客户页事件
        handleGrandSonEmit(){
            this.benchOrInfo = !this.benchOrInfo
        },
        //新增回访弹窗事件
        handleInfoEmit(){
            this.benchOrInfo = !this.benchOrInfo
        },
        //客户操作记录
        handleMiddleEvent(obj){
            this.$emit("clickNewAdd", obj)
        }
    },
    beforeDestroy(){
      
    }
}
</script>

<style scoped lang="scss">
.wrap{
    height: 100%;
    border-top: 1px solid #eee;
}
</style>